import { withInstall } from '@element-plus/utils/with-install'

import Icon from './src/icon.vue'

export const ElIcon = withInstall(Icon)
export default ElIcon

export * from './src/icon'
